module.exports = __webpack_public_path__ + "img/sebastiao.8c11bf97.jpeg";